module.exports = __webpack_public_path__ + "media/customizations/heritagelife/logo-e12388b0bf0848f7209b0deb4c7a3a8e.png";